import styled from "styled-components";

interface LogoProps {
  src: string;
}
const LogoContainer = styled.div`
  width: 4.99244rem;
  height: 2.3125rem;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 4.99244rem;
    height: 2.3125rem;
  }
`;
const LogoImg = styled.img`
  width: 100%;
  height: 100%;
  /* object-fit: contain; */
`;

const Logo = ({ src }: LogoProps) => {
  return (
    <LogoContainer>
      <LogoImg src={src} alt="" />
    </LogoContainer>
  );
};

export default Logo;
